export const IGetLanguagesUseCaseType = Symbol('IGetLanguagesUseCase');
